'use client'

import Image from 'next/image'

const images = [
  '/images/categories/silk-scarf.jpg',
  '/images/categories/earrings.jpg',
  '/images/categories/jackets.jpg',
  '/images/categories/necklaces.jpg',
]

export function ModernCommunity() {
  return (
    <section className="py-16 md:py-20 bg-[#1a1a2e] text-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold tracking-tight mb-2">
            Join the Community
          </h2>
          <p className="text-white/60 text-sm">
            Tag @aussiestyle on Instagram for a chance to be featured
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {images.map((src, i) => (
            <div key={i} className="relative aspect-square rounded-lg overflow-hidden group cursor-pointer">
              <Image
                src={src}
                alt={`Community ${i + 1}`}
                fill
                className="object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-center justify-center">
                <span className="text-white opacity-0 group-hover:opacity-100 transition-opacity text-2xl">♡</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
